<template>
  <button
    :aria-label="ariaLabel"
    :type="type"
    :tabindex="tabindex"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <slot></slot>
  </button>
</template>

<script>
  
export default {
  name: "BaseButton",
  inheritAttrs: false,

  props: {
    ariaLabel: { type: String, required: true },
    type: { type: String, default: "button" },
    tabindex: { type: [String, Number], required: false },
  }
};

</script>
